<template>
    <div class="pb-5" data-wizard-type="step-content" data-wizard-state="current">
        <div class="mb-10 font-weight-bold text-dark">Persönliche angaben ausfüllen</div>
        <div class="form-group fv-plugins-icon-container">
            <label>{{ __('user.email') }}</label>
            <input type="email"
                   class="form-control form-control-lg"
                   name="email"
                   placeholder="E-Mail"
                   v-model="formData.email"
            >
            <span class="form-text text-muted">Bitte geben Sie die E-Mail Adresse der einzuladenden Person ein</span>
            <div class="fv-plugins-message-container"/>
        </div>
        <div class="form-group fv-plugins-icon-container">
            <label>{{ __('user.phone') }}</label>
            <input type="text"
                   class="form-control form-control-lg"
                   name="phone"
                   placeholder="Telefonnummer"
                   v-model="formData.phone"
            >
            <span class="form-text text-muted">(Optional) Kann für Kontakaufnahme genutzt werden</span>
            <div class="fv-plugins-message-container"/>
        </div>
        <div v-if="Permission.ASSIGN_USER_ROLE" class="form-group fv-plugins-icon-container">
            <label>
                {{ __('user.role') }} <a v-show="Permission.VIEW_USER_ROLES"
                                         :href="$route('user.roles')" target="_new"
                                         class="text-dark">
                <i class="fas fa-info-circle"/>
            </a>
            </label>
            <multiselect
                v-model="formData.role"
                track-by="value"
                label="name"
                :allow-empty="false"
                :show-labels="false"
                :options="roles"
            >
            </multiselect>
            <span class="form-text text-muted">Bitte wählen Sie die Rolle des Benutzers</span>
            <div class="fv-plugins-message-container"/>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {PermissionsMixin} from "@js/permissions";

export default {
    components: {Multiselect},

    mixins: [PermissionsMixin],

    props: {
        value: Object,
        roles: Array
    },

    data() {
        return {
            formData: {
                email: null,
                phone: null,
                role: null
            }
        }
    },

    mounted() {
        this.formData = this.value;
    },

    watch: {
        formData: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
